export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 2_04.38354331.jpg";